"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gl_matrix_1 = require("gl-matrix");
/**
 * @author Kentaro Kawakatsu
 */
var Camera = /** @class */ (function () {
    function Camera(fov, aspect, zNear, zFar) {
        //
        this._cameraUP = gl_matrix_1.vec3.fromValues(0.0, 1.0, 0.0);
        //
        this._projectionMtx = gl_matrix_1.mat4.identity(gl_matrix_1.mat4.create());
        this._cameraMtx = gl_matrix_1.mat4.identity(gl_matrix_1.mat4.create());
        this._lookMtx = gl_matrix_1.mat4.identity(gl_matrix_1.mat4.create());
        //
        this.x = 0.0;
        this.y = 0.0;
        this.z = 0.0;
        gl_matrix_1.mat4.perspective(this._projectionMtx, fov, aspect, zNear, zFar);
    }
    Camera.prototype.getCameraMtx = function () {
        return this._cameraMtx;
    };
    Camera.prototype.lookAt = function (point) {
        gl_matrix_1.mat4.identity(this._lookMtx);
        gl_matrix_1.mat4.lookAt(this._lookMtx, gl_matrix_1.vec3.fromValues(this.x, this.y, this.z), point, this._cameraUP);
        gl_matrix_1.mat4.multiply(this._cameraMtx, this._projectionMtx, this._lookMtx);
    };
    Camera.DIRECTION = gl_matrix_1.vec3.fromValues(0.0, 0.0, 1.0);
    return Camera;
}());
exports.Camera = Camera;



//////////////////
// WEBPACK FOOTER
// ./src/ts/myLib/webgl/engine/Camera.ts
// module id = 19
// module chunks = 0